// import { fontList } from '../fontFetcher';

function FontSelection(props) {
    let fontArray = [
        "calling_coderegular",
        "pelagiadregular",
        "Almendra",
        "Benne Text",
        "Cherry Swash",
        "Fantasque Sans",
        "Finger Paint",
        "IBM Plex Serif"
    ]

    function options() {
        let options = [];
        for (let i = 0; i < fontArray.length; i++) {
            options.push(<option value={i}>{fontArray[i]}</option>)
        }
        return options;
    }

    return (
        <div className="uiElement">
            <h3>Font</h3>
            <select onChange={e => { props.setFontChoice(e.target.value); props.setFontName(fontArray[e.target.value]) }}>
                {/* <option>something else</option> */}
                {options()}
            </select>
        </div>
    )
}

export default FontSelection;